/**
 * The datasets this person was given on /me (#799): a contributor outside
 * Sitra signs in here as often as at the dataset's own link, and should find
 * their way to it. Only grants count, so an admin sees what they were given,
 * not every dataset. Draws `empty` when there are none or the list fails,
 * nothing while it loads.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Database } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';
import API_ENDPOINTS from '../../config/api';
import { CardButton, SectionTitle, Muted, TitleRow } from '../../screens/MeView.styles';

export default function MeDatasets({ empty = null }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [datasets, setDatasets] = useState(null); // null = loading

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_ENDPOINTS.ADMIN_DATASETS()}?mine=1`, { credentials: 'include' })
      .then((res) => (res.ok ? res.json() : { datasets: [] }))
      .then((data) => { if (!cancelled) setDatasets(data.datasets || []); })
      .catch(() => { if (!cancelled) setDatasets([]); });
    return () => { cancelled = true; };
  }, []);

  if (!datasets) return null;
  if (!datasets.length) return empty;

  return (
    <>
      <SectionTitle><Database size={15} /> {t('me.datasets.title')}</SectionTitle>
      {datasets.map((d) => (
        <CardButton key={d.id} onClick={() => navigate(`/admin/knowledge?dataset=${encodeURIComponent(d.id)}`)}>
          <TitleRow>
            <strong>{d.name}</strong>
            {d.my_action && <Muted as="span">{t(`datasetWorkspace.access.actions.${d.my_action}`)}</Muted>}
          </TitleRow>
          <Muted>{d.topic ? `${d.topic} · ` : ''}{t('me.datasets.sources', { count: d.source_count })}</Muted>
        </CardButton>
      ))}
    </>
  );
}
